import React, { useEffect, useMemo, useState } from 'react';
import * as Yup from 'yup';
import { useFormik, FormikProvider, Form, Field, ErrorMessage } from 'formik';
import { AADHAR_VALIDATION, Email_Validation, ERROR_MSG, MOBILE_VALIDATION } from '../CommonUtils/contextVariables';
import * as bie from 'react-bootstrap';
import { config } from '../CommonUtils/CommonURLS';
import { CommonAxiosGet, CommonAxiosPost } from '../CommonUtils/CommonAxios';
import allowNumbersOnly, { allowAlphabetAndSpacesOnly } from '../CommonUtils/CommonValidations';
import Swal from 'sweetalert2';
import { failureAlert, successAlert2 } from '../CommonUtils/SweetAlerts';
import { useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment';
import { AiFillFileText } from 'react-icons/ai';
import Select from "react-select";

function toSafeArray(val) {
    if (Array.isArray(val)) return val;
    if (val === null || val === undefined || val === '') return [];
    return [val];
}

function safeValue(val) {
    return val === null || val === undefined || val === 'null' ? '' : val;
}

function formatDateForInput(value) {
    if (!value) return '';
    if (value.includes('-') && value.split('-')[0].length === 4) return value;
    const parts = value.split('-');
    if (parts.length === 3) {
        return `${parts[2]}-${parts[1]}-${parts[0]}`;
    }
    return '';
}

function mapNonTeachingRow(row) {
    if (!row) return {};

    return {
        emp_full_name: row.emp_full_name || `${row.first_name || ''} ${row.last_name || ''}`.trim(),
        gender: row.gender,
        dob: row.dob,
        doj: row.doj,
        university_type: row.university_type,
        cfms_id: row.cfms_id,
        dept_id: row.dept_id,
        natue_post_id: row.natue_post_id,
        caste_desc: row.caste_desc,
        sub_caste_code: row.sub_caste_code,
        ews: row.ews,
        is_ph: row.is_ph,
        type_of_disability: row.type_of_disability,
        per_disability: row.per_disability,
        appoint_cat_id: row.appoint_cat_id,
        dist_id: row.dist_id,
        qual_id: row.qual_id || row.qual_id_lookup,
        mobile: row.mobile,
        email: row.email,
        aadhar: row.aadhar,
        desig: row.desig || row.post_desc,
        design_time_of_appointment: row.design_time_of_appointment || row.post_desc,
        coll_code: row.coll_code,
    };
}


export default function NonTeachingFacultyData() {
    const navigate = useNavigate();
    const location = useLocation();

    const ntEditData = location.state?.facultyData;
    const ntFormSourceData = useMemo(() => mapNonTeachingRow(ntEditData), [ntEditData]);
const isAddNewFaculty = location.state?.mode === "add";

console.log("Is Add New Faculty:", isAddNewFaculty);
    const ValidationSchema = Yup.object({
        ntFacName: Yup.string().required(ERROR_MSG),
        ntCfmsId: Yup.string().required(ERROR_MSG).matches(/^\d+$/, 'Only numbers are allowed'),
ntQualificationLater: Yup.array()
    .of(Yup.number())
    .min(1, ERROR_MSG)
    .required(ERROR_MSG),
            typeAppointment: Yup.string().required(ERROR_MSG),
        natureAppointment: Yup.string().required(ERROR_MSG),
        ntFatherName: Yup.string().required(ERROR_MSG),
        ntAddress: Yup.string().required(ERROR_MSG),
        ntGender: Yup.string().required(ERROR_MSG),
        ntDob: Yup.string().required(ERROR_MSG),
        ntDoj: Yup.string().required(ERROR_MSG),
        ntAadharNo: Yup.string().required(ERROR_MSG).matches(AADHAR_VALIDATION, 'Invalid Aadhaar Number'),
        ntDesignation: Yup.string().required(ERROR_MSG),
        ntCaste: Yup.string().required(ERROR_MSG),
        ntQualAppointOther: Yup.string().when('ntQualificationAppoint', {
            is: (val) => val?.length === 1 && val?.[0] === 17,
            then: (schema) => schema.required(ERROR_MSG),
            otherwise: (schema) => schema.notRequired(),
        }),
        ntQualLaterOther: Yup.string().when('ntQualificationLater', {
            is: (val) => val?.length === 1 && val?.[0] === 17,
            then: (schema) => schema.required(ERROR_MSG),
            otherwise: (schema) => schema.notRequired(),
        }),
        ntEws: Yup.string().when('ntCaste', {
            is: 'OC',
            then: (schema) => schema.required(ERROR_MSG),
            otherwise: (schema) => schema.notRequired(),
        }),
        ntSubCaste: Yup.string().required(ERROR_MSG),
        ntIsPh: Yup.string().required(ERROR_MSG),
        // ntUnvType: Yup.string().required(ERROR_MSG),
        ntTypeOfDisability: Yup.string().when('ntIsPh', {
            is: 'true',
            then: (schema) => schema.required(ERROR_MSG),
            otherwise: (schema) => schema.notRequired(),
        }),
        ntPerDisability: Yup.string().when('ntIsPh', {
            is: 'true',
            then: (schema) => schema.required(ERROR_MSG),
            otherwise: (schema) => schema.notRequired(),
        }),
        // ntAppointCat: Yup.string().notRequired(),
        ntAppointCat: Yup.string().required(ERROR_MSG),

        ntLocalDist: Yup.string().required(ERROR_MSG),
        ntDesignTimeOfAppointment: Yup.string().required(ERROR_MSG),
        ntQualificationAppoint: Yup.array()
            .of(Yup.number())
            .min(1, 'Select at least one qualification')
            .required(ERROR_MSG),
        ntContact: Yup.string().required(ERROR_MSG).nullable().matches(MOBILE_VALIDATION, 'Invalid mobile number'),
        // ntEmailId: Yup.string().required(ERROR_MSG).nullable().matches(Email_Validation, 'Invalid Email Address'),
        //  collCode: Yup.string().required(ERROR_MSG),

department: Yup.string()
    .required(ERROR_MSG),
salaryType: Yup.string().required(ERROR_MSG),
amount: Yup.string()
    .required(ERROR_MSG)
    .matches(/^\d+$/, 'Only numbers are allowed'),
salary: Yup.string()
    .required(ERROR_MSG)
    .matches(/^\d+$/, 'Only numbers are allowed'),
sourceSalary: Yup.string().required(ERROR_MSG),
superannYear: Yup.string()
    .required(ERROR_MSG)
    
    });
    const InitialValues = {
        ntFacName: ntFormSourceData ? safeValue(ntFormSourceData.emp_full_name) : '',
        ntGender: ntFormSourceData ? safeValue(ntFormSourceData.gender) : '',
        ntDob: formatDateForInput(ntFormSourceData?.dob),
        ntDoj: formatDateForInput(ntFormSourceData?.doj),
        ntUnvType: ntFormSourceData ? safeValue(ntFormSourceData.university_type) : '',
        ntCfmsId: ntFormSourceData ? safeValue(ntFormSourceData.cfms_id) : '',
        ntCaste: ntFormSourceData ? safeValue(ntFormSourceData.caste_desc) : '',
        ntSubCaste: ntFormSourceData ? safeValue(ntFormSourceData.sub_caste_code) : '',
        ntEws: ntFormSourceData ? String(ntFormSourceData.ews ?? '') : '',
        ntIsPh: ntFormSourceData ? safeValue(ntFormSourceData.is_ph) : '',
        ntTypeOfDisability: ntFormSourceData ? safeValue(ntFormSourceData.type_of_disability) : '',
        ntPerDisability: ntFormSourceData ? safeValue(ntFormSourceData.per_disability) : '',
        ntAppointCat: ntFormSourceData ? safeValue(ntFormSourceData.appoint_cat_id) : '',
        ntLocalDist: ntFormSourceData ? safeValue(ntFormSourceData.dist_id) : '',
        ntQualAppointOther: '',
        ntQualLaterOther: '',
        ntQualificationAppoint: ntFormSourceData
            ? toSafeArray(ntFormSourceData.qual_id).map(Number)
            : [],
        ntQualificationLater: ntFormSourceData
            ? toSafeArray(ntFormSourceData.qual_id).map(Number)
            : [],
        ntContact: ntFormSourceData ? safeValue(ntFormSourceData.mobile) : '',
        ntEmailId: ntFormSourceData ? safeValue(ntFormSourceData.email) : '',
        ntAadharNo: ntFormSourceData ? safeValue(ntFormSourceData.aadhar) : '',
        ntDesignation: ntFormSourceData ? safeValue(ntFormSourceData.desig) : '',
        ntDesignTimeOfAppointment: ntFormSourceData ? safeValue(ntFormSourceData.design_time_of_appointment) : '',
        ntIsNewFaculty: ntFormSourceData ? false : true,
        // collCode: ntFormSourceData ? safeValue(ntFormSourceData.coll_code) : '',
department: ntFormSourceData ? safeValue(ntFormSourceData.dept) : '',
typeAdepartment: ntFormSourceData ? safeValue(ntFormSourceData.dept) : '',

typeAppointment: ntFormSourceData
    ? String(safeValue(ntFormSourceData.type_appointment || ntFormSourceData.nature_of_post_name)).toUpperCase()
    : '',

salaryType: ntFormSourceData
    ? safeValue(
          ntFormSourceData.salary_type ||
          (ntFormSourceData.basicpay ? 'SCALE' : ntFormSourceData.consolidated_amount ? 'CONSOLIDATED PAY' : '')
      )
    : '',

amount: ntFormSourceData
    ? String(safeValue(ntFormSourceData.amount || ntFormSourceData.basicpay || ntFormSourceData.consolidated_amount))
    : '',

salary: ntFormSourceData ? String(safeValue(ntFormSourceData.salary)) : '',
sourceSalary: ntFormSourceData ? safeValue(ntFormSourceData.source_salary) : '',
superannYear: ntFormSourceData ? String(safeValue(ntFormSourceData.superann_year)) : '',
ntFatherName: '',
ntAddress:'',
natureAppointment:"",
regularizationDate:"",

    };

    const ntFacultyDetailsFormik = useFormik({
        initialValues: InitialValues,
        validationSchema: ValidationSchema,
        enableReinitialize: true,
        onSubmit: (val) => {
            // const payload = {
            //     facName: val.ntFacName,
            //     gender: val.ntGender,
            //     dob: val.ntDob,
            //     doj: val.ntDoj,
            //     unvType: val.ntUnvType,
            //     cfmsId: val.ntCfmsId,
            //     caste: val.ntCaste,
            //     subCaste: val.ntSubCaste,
            //     ews: val.ntEws,
            //     isPh: val.ntIsPh,
            //     typeOfDisability: val.ntTypeOfDisability,
            //     perDisability: val.ntPerDisability,
            //     appointCat: val.ntAppointCat,
            //     localDist: val.ntLocalDist,
            //     qualAppointOther: val.ntQualAppointOther,
            //     qualLaterOther: val.ntQualLaterOther,
            //     qualificationAppoint: val.ntQualificationAppoint,
            //     qualificationLater: val.ntQualificationLater,
            //     contact: val.ntContact,
            //     emailId: val.ntEmailId,
            //     aadharNo: val.ntAadharNo,
            //     designation: val.ntDesignation,
            //     designTimeOfAppointment: val.ntDesignTimeOfAppointment,
            //     isNewFaculty: val.ntIsNewFaculty,
            // };

            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    const url = `${config.url.FAC_URL}nonTeachingFaculty`;
                    CommonAxiosPost(url, val).then((res) => {
                        if (res?.data?.scode === '01') {
                            successAlert2(res?.data?.sdesc).then(() => {
                                navigate('/NonTeachingFaculty');
                            });
                        } else if (res?.data?.scode === '02') {
                            Swal.fire(res?.data?.sdesc, '', 'error');
                        } else {
                            failureAlert('Failed to submit');
                        }
                    });
                }
            });
        },
    });

    const [facultyType, setFacultyType] = useState([]);
    const [appointedCategory, setAppointedCategory] = useState([]);
    const [subCasteList, setSubCasteList] = useState([]);
    const [casteList, setCasteList] = useState([]);
    const [distlist, setDistlist] = useState([]);
    const [qualification, setQualification] = useState([]);
    const [nonTeachingDesignations, setNonTeachingDesignations] = useState([]);

    function getAppointedCategory() {
        const url = `${config.url.FAC_URL}getAppointedCatList`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setAppointedCategory(res.data.AppointedCategory || []);
            } else {
                setAppointedCategory([]);
            }
        });
    }

    function getCaste() {
        const url = `${config.url.FAC_URL}geSubCasteList`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                const cleanedData = (res.data.subCaste || []).map((item) => ({
                    ...item,
                    sub_caste_name: item.sub_caste_name?.trim(),
                }));
                setSubCasteList(cleanedData);
                const uniqueCastes = [...new Set(cleanedData.map((item) => item.caste_code))];
                setCasteList(uniqueCastes);
            }
        });
    }

    const fetchDistList = async () => {
        const res = await CommonAxiosGet(`${config.url.FAC_URL}getDistricts`);
        setDistlist(res?.data?.scode === '01' ? res.data.getDistricts : []);
    };

    const qualificationList = async () => {
        const res = await CommonAxiosGet(`${config.url.FAC_URL}getQualificationList`);
        setQualification(res?.data?.scode === '01' ? res.data.Qualification : []);
    };

    function getNonTeachingDesignationList() {
        const url = `${config.url.FAC_URL}getnonteachingdesig`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                const rawList = res?.data?.data || [];
                setNonTeachingDesignations(rawList);
            } else {
                setNonTeachingDesignations([]);
            }
        });
    }

      // *******College Details --get api*******
        const [collegeDetails, setCollegeDetails] = useState([]);
        function GetCollegeDetails() {
            let url = `${config.url.FAC_URL}getCollegedetails`;
            CommonAxiosGet(url).then((res) => {
                if (res?.data?.scode === "01") {
                    setCollegeDetails(res.data.data);
                } else {
                    setCollegeDetails([]);
                }
            });
        }
    const [deptname, setDeptname] = useState([]);

    const getDeptList = async () => {
        const res = await CommonAxiosGet(
            `${config.url.FAC_URL}getDept`
        );
        setDeptname(res?.data?.scode === "01" ? res.data.data : []);
    };
    useEffect(() => {
        getCaste();
        getDeptList();
        qualificationList();
        getAppointedCategory();
        fetchDistList();
        getNonTeachingDesignationList();
        GetCollegeDetails();
    }, []);

    const filteredSubCaste = subCasteList.filter(
        (item) => item.caste_code === ntFacultyDetailsFormik.values.ntCaste
    );                                                                                                                                
const appointmentTypes = ['REGULAR', 'TIME SCALE', '28 DAYS', 'CONSOLIDATED PAY', 'NMR',"OUTSOURCING","CONTRACT","COMPASSIONATE GROUNDS"];
const appointmentTypesondate = ['REGULAR', 'TIME SCALE', '28 DAYS', 'CONSOLIDATED PAY', 'NMR',"OUTSOURCING","CONTRACT"];

 
const salaryTypes = ['SCALE', 'CONSOLIDATED PAY', 'DAILY BASIS'];
 
// Label of the dynamic input changes with the selected salary type
const salaryAmountLabel = {
    'SCALE': 'Basic Pay',
    'CONSOLIDATED PAY': 'Pay Amount',
    'DAILY BASIS': 'Day Amount',
    
};
 
const fundSources = ['Government', 'Internal Funds'];
 
// Superannuation year: current year to +40 years
 
// Allow digits only
const onlyNumbers = (value) => value.replace(/\D/g, '');
    return (
        <>
            <div className='faculty-form-wrapper'>
                <div className='faculty-card'>
                    <div className='fac-topbar'>
                        <div className='fac-detnew'>
                            <h5 className='mb-0'>{ntEditData ? 'Edit Non-Teaching Details' : 'Add Non-Teaching Details'}</h5>
                        </div>
                        <button
                            className='newfacbtn btn btn-primary d-flex align-items-center'
                            onClick={() => navigate('/NonTeachingFaculty')}
                            style={{ gap: '8px' }}
                        >
                            <AiFillFileText size={20} />
                            Go to Non-Teaching Report
                        </button>
                    </div>

                    <FormikProvider value={ntFacultyDetailsFormik}>
                        <Form
                            className='form_adjust'
                            onSubmit={ntFacultyDetailsFormik.handleSubmit}
                            onChange={ntFacultyDetailsFormik.handleChange}
                        >
                            <h5 className='mb-3 innerheader-new'><span>Personal </span>Details</h5>
                            <bie.Row>
                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className='mb-2'>
                                    <label>Employee Name</label>
                                    <Field
                                        name='ntFacName'
                                        className='form-control'
                                        maxLength={60}
                                        onKeyPress={allowAlphabetAndSpacesOnly}
                                        disabled={ntEditData?.emp_full_name}
                                    />
                                    <ErrorMessage name='ntFacName' component='div' className='text-danger' />
                                </bie.Col>
 <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className='mb-2'>
                                    <label>Father Name</label>
                                    <Field
                                        name='ntFatherName'
                                        className='form-control'
                                        maxLength={80}
                                        onKeyPress={allowAlphabetAndSpacesOnly}
                                    />
                                    <ErrorMessage name='ntFatherName' component='div' className='text-danger' />
                                </bie.Col>
                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className='mb-2'>
                                    <label>Gender</label>
                                    <Field as='select' name='ntGender' className='form-control' disabled={ntEditData?.gender}>
                                        <option value=''>---Select---</option>
                                        <option value='Male'>Male</option>
                                        <option value='Female'>Female</option>
                                    </Field>
                                    <ErrorMessage name='ntGender' component='div' className='text-danger' />
                                </bie.Col>

                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className='mb-2'>
                                    <label>Date of Birth</label>
                                    <Field type='date' name='ntDob' className='form-control' max='2002-12-31' disabled={ntEditData?.dob} />
                                    <ErrorMessage name='ntDob' component='div' className='text-danger' />
                                </bie.Col>

                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className='mb-2'>
                                    <label>Aadhaar No</label>
                                    <Field
                                        name='ntAadharNo'
                                        className='form-control'
                                        maxLength={12}
                                        onKeyPress={allowNumbersOnly}
                                        disabled={ntEditData?.aadhar}
                                    />
                                    <ErrorMessage name='ntAadharNo' component='div' className='text-danger' />
                                </bie.Col>

                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className='mb-2'>
                                    <label>Mobile Number</label>
                                    <Field
                                        name='ntContact'
                                        className='form-control'
                                        onKeyPress={allowNumbersOnly}
                                        maxLength={10}
                                    />
                                    <ErrorMessage name='ntContact' component='div' className='text-danger' />
                                </bie.Col>

                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className='mb-2'>
                                    <label>Email ID</label>
                                    <Field type='email' name='ntEmailId' className='form-control' maxLength={70} />
                                    <ErrorMessage name='ntEmailId' component='div' className='text-danger' />
                                </bie.Col>

                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className='mb-2'>
                                    <label>Local District</label>
                                    <Field as='select' name='ntLocalDist' className='form-control form-control-md'>
                                        <option value=''>---select---</option>
                                        {distlist?.map((d) => (
                                            <option key={d.dist_code} value={d.dist_code}>
                                                {d.dist_name}
                                            </option>
                                        ))}
                                    </Field>
                                    <ErrorMessage name='ntLocalDist' component='div' className='text-danger' />
                                </bie.Col>
                                 <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className='mb-2'>
                                    <label>Enter Address</label>
                                    <Field as='textarea' name='ntAddress' className='form-control form-control-md' placeholder='Enter Address' maxLength='300' />
                                    <ErrorMessage name='ntAddress' component='div' className='text-danger' />
                                </bie.Col>
                            </bie.Row>

                            <h5 className='mt-3 mb-3 innerheader-new'><span>Professional</span> Details</h5>
                            <bie.Row>
                                {/* <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className='mb-2'>
                                    <label>Type of University</label>
                                    <Field as='select' name='ntUnvType' className='form-control'>
                                        <option value=''>--Select--</option>
                                        <option value='Technical University'>Technical University</option>
                                        <option value='Multi-Discipline University'>Multi-Discipline University</option>
                                    </Field>
                                    <ErrorMessage name='ntUnvType' component='div' className='text-danger' />
                                </bie.Col> */}

                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className='mb-2'>
                                    <label>Date of Joining in the university</label>
                                    <Field
                                        type='date'
                                        name='ntDoj'
                                        className='form-control'
                                        min={
                                            ntFacultyDetailsFormik.values.ntDob
                                                ? moment(ntFacultyDetailsFormik.values.ntDob).add(18, 'years').format('YYYY-MM-DD')
                                                : ''
                                        }
                                        onKeyDown={(e) => e.preventDefault()}
                                    />
                                    <ErrorMessage name='ntDoj' component='div' className='text-danger' />
                                </bie.Col>
                                 <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className='mb-2'>
                                    <label>Date of Regularization</label>
                                    <Field
                                        type='date'
                                        name='regularizationDate'
                                        className='form-control'
                                       
                                        onKeyDown={(e) => e.preventDefault()}
                                    />
                                    {/* <ErrorMessage name='regularizationDate' component='div' className='text-danger' /> */}
                                </bie.Col>

                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className='mb-2'>
                                    <label>CFMS ID/Employee ID</label>
                                    <Field name='ntCfmsId' className='form-control' onKeyPress={allowNumbersOnly} maxLength={13} />
                                    <ErrorMessage name='ntCfmsId' component='div' className='text-danger' />
                                </bie.Col>

                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className='mb-2'>
                                    <label>Current Designation</label>
                                    <Field as='select' name='ntDesignation' className='form-control'>
                                        <option value=''>---Select---</option>
                                        {nonTeachingDesignations.map((desig, index) => (
                                            <option key={`${desig.post_desc}-${index}`} value={desig.post_desc}>
                                                {desig.post_desc}
                                            </option>
                                        ))}
                                    </Field>
                                    <ErrorMessage name='ntDesignation' component='div' className='text-danger' />
                                </bie.Col>

                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className='mb-2'>
                                    <label>Designation at the time of Appointment</label>
                                    <Field as='select' name='ntDesignTimeOfAppointment' className='form-control'>
                                        <option value=''>---Select---</option>
                                        {nonTeachingDesignations.map((desig, index) => (
                                            <option key={`${desig.post_desc}-appointment-${index}`} value={desig.post_desc}>
                                                {desig.post_desc}
                                            </option>
                                        ))}
                                    </Field>
                                    <ErrorMessage name='ntDesignTimeOfAppointment' component='div' className='text-danger' />
                                </bie.Col>

                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className='mb-2'>
                                    <label>Appointed Category</label>
                                    <select
                                        name='ntAppointCat'
                                        className='form-control'
                                        value={ntFacultyDetailsFormik.values.ntAppointCat}
                                        onChange={ntFacultyDetailsFormik.handleChange}
                                    >
                                        <option value=''>--Select Appointed Category--</option>
                                        {appointedCategory?.map((app, index) => (
                                            <option key={index} value={app?.appoint_cat_id}>
                                                {app?.appoint_cat_name}
                                            </option>
                                        ))}
                                    </select>
                                    <ErrorMessage name='ntAppointCat' component='div' className='text-danger' />
                                </bie.Col>

                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className='mb-2'>
                                    <label>Qualifications at the time of appointment</label>
                                    <Select
                                        name='ntQualificationAppoint'
                                        options={qualification?.map((item) => ({
                                            value: item.qual_id,
                                            label: item.qual_name,
                                        }))}
                                        isMulti
                                        value={
                                            qualification
                                                ?.map((item) => ({
                                                    value: item.qual_id,
                                                    label: item.qual_name,
                                                }))
                                                .filter(
                                                    (option) =>
                                                        Array.isArray(ntFacultyDetailsFormik.values.ntQualificationAppoint) &&
                                                        ntFacultyDetailsFormik.values.ntQualificationAppoint.includes(option.value)
                                                ) || []
                                        }
                                        onChange={(selectedOptions) => {
                                            const values = selectedOptions ? selectedOptions.map((o) => o.value) : [];
                                            ntFacultyDetailsFormik.setFieldValue('ntQualificationAppoint', values);
                                            if (!(values.length === 1 && values[0] === 17)) {
                                                ntFacultyDetailsFormik.setFieldValue('ntQualAppointOther', '');
                                            }
                                        }}
                                        onBlur={() => ntFacultyDetailsFormik.setFieldTouched('ntQualificationAppoint', true)}
                                        placeholder='--Select Qualification--'
                                        isSearchable
                                        isClearable
                                        classNamePrefix='react-select'
                                    />
                                    <ErrorMessage name='ntQualificationAppoint' component='div' className='text-danger' />
                                </bie.Col>

                                {ntFacultyDetailsFormik.values.ntQualificationAppoint?.length === 1 &&
                                    ntFacultyDetailsFormik.values.ntQualificationAppoint?.[0] === 17 && (
                                        <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className='mb-2'>
                                            <label>Other Qualifications at the time of Appointment</label>
                                            <Field type='text' name='ntQualAppointOther' className='form-control' maxLength={30} />
                                            <ErrorMessage name='ntQualAppointOther' component='div' className='text-danger' />
                                        </bie.Col>
                                    )}

                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className='mb-2'>
                                    <label>Qualification Acquired Later</label>
                                    <Select
                                        name='ntQualificationLater'
                                        options={qualification?.map((item) => ({
                                            value: item.qual_id,
                                            label: item.qual_name,
                                        }))}
                                        isMulti
                                        value={
                                            qualification
                                                ?.map((item) => ({
                                                    value: item.qual_id,
                                                    label: item.qual_name,
                                                }))
                                                .filter((option) => ntFacultyDetailsFormik.values.ntQualificationLater?.includes(option.value)) || []
                                        }
                                        onChange={(selectedOptions) => {
                                            const values = selectedOptions ? selectedOptions.map((option) => option.value) : [];
                                            ntFacultyDetailsFormik.setFieldValue('ntQualificationLater', values);
                                            if (!(values.length === 1 && values[0] === 17)) {
                                                ntFacultyDetailsFormik.setFieldValue('ntQualLaterOther', '');
                                            }
                                        }}
                                        onBlur={() => ntFacultyDetailsFormik.setFieldTouched('ntQualificationLater', true)}
                                        placeholder='--Select Qualification--'
                                        isSearchable
                                        isClearable
                                        classNamePrefix='react-select'
                                    />
                                            <ErrorMessage name='ntQualificationLater' component='div' className='text-danger' />

                                </bie.Col>

                                {ntFacultyDetailsFormik.values.ntQualificationLater?.length === 1 &&
                                    ntFacultyDetailsFormik.values.ntQualificationLater?.[0] === 17 && (
                                        <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className='mb-2'>
                                            <label>Other Qualification Acquired Later</label>
                                            <Field type='text' name='ntQualLaterOther' className='form-control' maxLength={30} />
                                            <ErrorMessage name='ntQualLaterOther' component='div' className='text-danger' />
                                        </bie.Col>
                                    )}
                            </bie.Row>

                            <h5 className='mt-3 innerheader-new'><span>Caste</span> Details</h5>
                            <bie.Row>
                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className='mb-2'>
                                    <label>Caste Category</label>
                                    <select
                                        name='ntCaste'
                                        className='form-control'
                                        value={ntFacultyDetailsFormik.values.ntCaste}
                                        onChange={(e) => {
                                            ntFacultyDetailsFormik.handleChange(e);
                                            ntFacultyDetailsFormik.setFieldValue('ntSubCaste', '');
                                            ntFacultyDetailsFormik.setFieldValue('ntEws', '');
                                        }}
                                    >
                                        <option value=''>--Select Caste--</option>
                                        {casteList?.map((casteCode, index) => (
                                            <option key={index} value={casteCode}>
                                                {casteCode}
                                            </option>
                                        ))}
                                    </select>
                                    <ErrorMessage name='ntCaste' component='div' className='text-danger' />
                                </bie.Col>

                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className='mb-2'>
                                    <label>Sub Caste</label>
                                    <Select
                                        name='ntSubCaste'
                                        options={filteredSubCaste.map((item) => ({
                                            value: item.sub_caste_code,
                                            label: item.sub_caste_name,
                                        }))}
                                        value={
                                            filteredSubCaste
                                                .map((item) => ({ value: item.sub_caste_code, label: item.sub_caste_name }))
                                                .find((option) => option.value === ntFacultyDetailsFormik.values.ntSubCaste) || null
                                        }
                                        onChange={(selectedOption) => {
                                            ntFacultyDetailsFormik.setFieldValue('ntSubCaste', selectedOption ? selectedOption.value : '');
                                        }}
                                        placeholder='--Select Sub Caste--'
                                        isSearchable
                                        classNamePrefix='react-select'
                                    />
                                    <ErrorMessage name='ntSubCaste' component='div' className='text-danger' />
                                </bie.Col>

                                {ntFacultyDetailsFormik.values.ntCaste === 'OC' && (
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className='mb-2'>
                                        <label>Whether belongs to EWS category?</label>
                                        <div className='form-border'>
                                            <Field type='radio' value='true' name='ntEws' className='form-sub me-1' /> Yes &nbsp;&nbsp;
                                            <Field type='radio' value='false' name='ntEws' className='form- me-1' /> No
                                        </div>
                                        <ErrorMessage name='ntEws' component='div' className='text-danger' />
                                    </bie.Col>
                                )}
                            </bie.Row>

                             {/* ================= COLLEGE DETAILS ================= */}
                            {/* <h5 className="mt-3 innerheader-new"><span>College</span> Details</h5>
                            <bie.Row>
                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className="mb-2">
                                    <label>Select College</label>
                                    <select
                                        name="collCode"
                                        className="form-control"
                                        value={ntFacultyDetailsFormik.values.collCode}
                                        onChange={ntFacultyDetailsFormik.handleChange}
                                    >
                                        <option value="">---select---</option>
                                        {collegeDetails?.map((d) => (
                                            <option key={d.coll_code} value={d.coll_code}>
                                                {d.coll_name}
                                            </option>
                                        ))}
                                    </select>
                                    <ErrorMessage name="collCode" component="div" className="text-danger" />
                                </bie.Col>
                            </bie.Row> */}

                            <h5 className='mt-3 innerheader-new'><span>PH</span> Details</h5>
                            <bie.Row>
                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className='mb-2'>
                                    <label>Physically Challenged</label>
                                    <Field
                                        as='select'
                                        name='ntIsPh'
                                        className='form-control'
                                        onChange={(e) => {
                                            ntFacultyDetailsFormik.handleChange(e);
                                            ntFacultyDetailsFormik.setFieldValue('ntTypeOfDisability', '');
                                            ntFacultyDetailsFormik.setFieldValue('ntPerDisability', '');
                                        }}
                                    >
                                        <option value=''>--Select--</option>
                                        <option value='true'>Yes</option>
                                        <option value='false'>No</option>
                                    </Field>
                                    <ErrorMessage name='ntIsPh' component='div' className='text-danger' />
                                </bie.Col>

                                {ntFacultyDetailsFormik.values.ntIsPh === 'true' && (
                                    <>
                                        <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className='mb-3'>
                                            <label>Type of Disability</label>
                                            <Field as='select' name='ntTypeOfDisability' className='form-control'>
                                                <option value=''>--Select--</option>
                                                <option value='MENTAL DISABILITY / MULTIPLE DISABILITY(MD)'>MENTAL / MULTIPLE DISABILITY</option>
                                                <option value='ORTHOPEDICALLY HANDICAPPED(OH)'>ORTHOPEDICALLY HANDICAPPED</option>
                                                <option value='HEARING IMPAIRED(HI)'>HEARING IMPAIRED</option>
                                                <option value='VISUALLY IMPAIRED(VI)'>VISUALLY IMPAIRED</option>
                                            </Field>
                                            <ErrorMessage name='ntTypeOfDisability' component='div' className='text-danger' />
                                        </bie.Col>

                                        <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className='mb-3'>
                                            <label>Percentage of Disability</label>
                                            <Field as='select' name='ntPerDisability' className='form-control'>
                                                <option value=''>--Select--</option>
                                                <option value='40-45'>40-45 %</option>
                                                <option value='46-50'>46-50 %</option>
                                                <option value='51-55'>51-55 %</option>
                                                <option value='56-60'>56-60 %</option>
                                                <option value='61-65'>61-65 %</option>
                                                <option value='66-70'>66-70 %</option>
                                                <option value='Above 70'>Above 70 %</option>
                                            </Field>
                                            <ErrorMessage name='ntPerDisability' component='div' className='text-danger' />
                                        </bie.Col>
                                    </>
                                )}
                            </bie.Row>



                            <h5 className='mt-3 innerheader-new'><span>PAY</span> Details</h5>


<bie.Row>
    {/* <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className='mb-2'>
        <label>Department</label>
        <input
            type='text'
            name='department'
            className='form-control'
            placeholder='Enter Department'
            value={ntFacultyDetailsFormik.values.department}
            onChange={ntFacultyDetailsFormik.handleChange}
        />
        <ErrorMessage name='department' component='div' className='text-danger' />
    </bie.Col>
  */}
  <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className="mb-2">
                                    <label>Department / Subject</label>

                                    <Select
                                        name="department"
                                        options={deptname?.map((item) => ({
                                            value: item.dept_id,
                                            label: item.dept_name,
                                        }))}

                                        value={
                                            deptname
                                                ?.map((item) => ({
                                                    value: item.dept_id,
                                                    label: item.dept_name,
                                                }))
                                                .find(
                                                    (option) =>
                                                        option.value === ntFacultyDetailsFormik.values.department
                                                ) || null
                                        }

                                        onChange={(selectedOption) => {
                                            ntFacultyDetailsFormik.setFieldValue(
                                                "department",
                                                selectedOption ? selectedOption.value : ""
                                            );
                                        }}

                                        placeholder="--Select Department--"
                                        isSearchable
                                        classNamePrefix="react-select"
                                    />

                                    <ErrorMessage
                                        name="department"
                                        component="div"
                                        className="text-danger"
                                    />
                                </bie.Col>


    <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className='mb-2'>
        <label>Nature of Initial Appointment</label>
        <select
            name='typeAppointment'
            className='form-control'
            value={ntFacultyDetailsFormik.values.typeAppointment}
            onChange={ntFacultyDetailsFormik.handleChange}
        >
            <option value=''>--Select--</option>
            {appointmentTypes.map((type) => (
                <option key={type} value={type}>
                    {type}
                </option>
            ))}
        </select>
        <ErrorMessage name='typeAppointment' component='div' className='text-danger' />
    </bie.Col>
 <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className='mb-2'>
        <label>Nature of Appointment as on date</label>
        <select
            name='natureAppointment'
            className='form-control'
            value={ntFacultyDetailsFormik.values.natureAppointment}
            onChange={ntFacultyDetailsFormik.handleChange}
        >
            <option value=''>--Select --</option>
            {appointmentTypesondate.map((type) => (
                <option key={type} value={type}>
                    {type}
                </option>
            ))}
        </select>
        <ErrorMessage name='natureAppointment' component='div' className='text-danger' />
    </bie.Col>
    {/* SALARY TYPE - select (clears the amount when changed) */}
    <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className='mb-2'>
        <label>Salary Type</label>
        <select
            name='salaryType'
            className='form-control'
            value={ntFacultyDetailsFormik.values.salaryType}
            onChange={(e) => {
                ntFacultyDetailsFormik.handleChange(e);
                ntFacultyDetailsFormik.setFieldValue('amount', '');
            }}
        >
            <option value=''>--Select Salary Type--</option>
            {salaryTypes.map((type) => (
                <option key={type} value={type}>
                    {type}
                </option>
            ))}
        </select>
        <ErrorMessage name='salaryType' component='div' className='text-danger' />
    </bie.Col>
 
    {/* DYNAMIC AMOUNT - label changes with salary type, numbers only */}
    {ntFacultyDetailsFormik.values.salaryType && (
        <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className='mb-2'>
            <label>{salaryAmountLabel[ntFacultyDetailsFormik.values.salaryType]}</label>
            <input
                type='text'
                inputMode='numeric'
                name='amount'
                className='form-control'
                placeholder={`Enter ${salaryAmountLabel[ntFacultyDetailsFormik.values.salaryType]}`}
                value={ntFacultyDetailsFormik.values.amount}
                onChange={(e) =>
                    ntFacultyDetailsFormik.setFieldValue('amount', onlyNumbers(e.target.value))
                }
            />
            <ErrorMessage name='amount' component='div' className='text-danger' />
        </bie.Col>
    )}
 
    {/* SALARY (AS PER PREVIOUS MONTH) - numbers only */}
    <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className='mb-2'>
        <label>Salary (As per Previous Month)</label>
        <input
            type='text'
            inputMode='numeric'
            name='salary'
            className='form-control'
            placeholder='Enter Salary'
            maxLength={9}
            value={ntFacultyDetailsFormik.values.salary}
            onChange={(e) =>
                ntFacultyDetailsFormik.setFieldValue('salary', onlyNumbers(e.target.value))
            }
        />
        <ErrorMessage name='salary' component='div' className='text-danger' />
    </bie.Col>
 
    {/* SOURCE OF FUNDS FOR SALARY - select */}
    <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className='mb-2'>
        <label>Source of Funds for Salary</label>
        <select
            name='sourceSalary'
            className='form-control'
            value={ntFacultyDetailsFormik.values.sourceSalary}
            onChange={ntFacultyDetailsFormik.handleChange}
        >
            <option value=''>--Select Source of Funds--</option>
            {fundSources.map((src) => (
                <option key={src} value={src}>
                    {src}
                </option>
            ))}
        </select>
        <ErrorMessage name='sourceSalary' component='div' className='text-danger' />
    </bie.Col>
 
    {/* SUPERANNUATION YEAR - select */}
    <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className='mb-2'>
        <label>Superannuation Year</label>
       <Field
    type='date'
    name='superannYear'
    className='form-control'
    value={ntFacultyDetailsFormik.values.superannYear}
    onChange={(e) =>
        ntFacultyDetailsFormik.handleChange(e)
    }
/>
        <ErrorMessage name='superannYear' component='div' className='text-danger' />
    </bie.Col>
</bie.Row>



                            <div className='d-flex justify-content-end mt-3'>
                                <button type='submit' className='submit-btn btn-sm btn'>
                                    Submit
                                </button>
                            </div>
                        </Form>
                    </FormikProvider>
                </div>
            </div>
        </>
    );
}
